


















import {Component, Prop, Vue} from "vue-property-decorator";
import {IBooleanRule} from "@/modules/Segmentation/models/SegmentationRules";
import RangeIntForm from "@/components/RangeIntForm.vue";

@Component({
    components: {RangeIntForm}
})
export default class SwitchFormSwitchable extends Vue {
    @Prop() public readonly value!: IBooleanRule;
    @Prop() public readonly label?: string;
    @Prop() public readonly yesLabel?: string;
    @Prop() public readonly yesHint?: string;
    @Prop() public readonly noLabel?: string;
    @Prop() public readonly noHint?: string;

    get holeLabel(): string {
        const addStr: string = this.value.boolean
            ? this.yesLabel || ""
            : this.noLabel || "";

        return this.label + addStr;

    }

    get hint(): string {
        const str: string = this.isActive ? 'Будет проверяться' : 'Не будет проверяться';
        const addStr: string = this.value.boolean
            ? this.yesHint || ""
            : this.noHint || "";

        return str + addStr;
    }

    get isActive(): boolean {
        return this.value.boolean !== null;
    }

    set isActive(val: boolean) {
        if (!val) {
            this.value.boolean = null;
        } else {
            this.value.boolean = false;
        }
    }
}
